import algoliasearch, { SearchClient } from "algoliasearch";

// User Token Management
let cachedToken: string | null = null;

export const getAlgoliaUserToken = (): string => {
  if (cachedToken) {
    return cachedToken;
  }

  if (typeof window !== "undefined") {
    try {
      const stored = localStorage.getItem("algolia_user_token");
      if (stored) {
        cachedToken = stored;
        return stored;
      }
    } catch {}
  }

  const newToken = `anonymous-${Date.now()}-${Math.random()
    .toString(36)
    .substring(2, 11)}`;

  if (typeof window !== "undefined") {
    try {
      localStorage.setItem("algolia_user_token", newToken);
    } catch {}
  }

  return newToken;
};

// Search Client
export const initAlgoliaSearch = (): SearchClient => {
  const ID = process.env.NEXT_PUBLIC_ALGOLIA_ID;
  const KEY = process.env.NEXT_PUBLIC_ALGOLIA_KEY;

  if (!ID) {
    throw new Error("Missing Algolia ID");
  }
  if (!KEY) {
    throw new Error("Missing Algolia Key");
  }

  return algoliasearch(ID, KEY);
};

// Global Indices
export const initAlgoliaIndices = () => {
  const EN_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_GLOBAL_SEARCH_INDEX_EN;
  const ZH_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_GLOBAL_SEARCH_INDEX_ZH;
  const JA_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_GLOBAL_SEARCH_INDEX_JA;
  const ES_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_GLOBAL_SEARCH_INDEX_ES;
  const DE_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_GLOBAL_SEARCH_INDEX_DE;
  const FR_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_GLOBAL_SEARCH_INDEX_FR;

  if (!EN_INDEX) {
    throw new Error("Missing Algolia Global Search Index for English");
  }
  if (!ZH_INDEX) {
    throw new Error("Missing Algolia Global Search Index for Chinese");
  }
  if (!JA_INDEX) {
    throw new Error("Missing Algolia Global Search Index for Japanese");
  }
  if (!ES_INDEX) {
    throw new Error("Missing Algolia Global Search Index for Spanish");
  }
  if (!DE_INDEX) {
    throw new Error("Missing Algolia Global Search Index for German");
  }
  if (!FR_INDEX) {
    throw new Error("Missing Algolia Global Search Index for French");
  }

  return {
    en: EN_INDEX,
    zh: ZH_INDEX,
    ja: JA_INDEX,
    es: ES_INDEX,
    de: DE_INDEX,
    fr: FR_INDEX,
  } as const;
};

// Investor Indices
export const initAlgoliaInvestorIndices = () => {
  const EN_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_INVESTOR_SEARCH_INDEX_EN;
  const SV_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_INVESTOR_SEARCH_INDEX_SV;

  if (!EN_INDEX) {
    throw new Error("Missing Algolia Pressrelease Search Index for English");
  }
  if (!SV_INDEX) {
    throw new Error("Missing Algolia Pressrelease Search Index for Swedish");
  }
  return {
    en: EN_INDEX,
    sv: SV_INDEX,
  } as const;
};
